import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { PetitumAdapter } from '../../components/fascicolo/sezione-economica-data-interessi-edit/petitum-adapter';
import { Petitum } from '../../models/petitum';
import { BaseForm } from '../base-Form';

@Component({
    selector: 'div [valore-economico-altri-importi-form]',
  templateUrl: 'valore-economico-altri-importi-form.component.html'
})

export abstract class ValoreEconomicoAltriImportiFormComponent extends BaseForm {
  request: Petitum;
  altriImportiForm: FormGroup;

  abstract getPetitum(): Petitum;
  abstract getRequest(request: Petitum);

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super();
  }

  initRequest() {
    this.request = new PetitumAdapter(this.getPetitum()).petitum;
  }

  createForm() {
      this.initRequest();
      this.altriImportiForm = this.campiForm.group({
      costiGestione: [this.request.costiGestione],
      speseRegistrazione: [this.request.speseRegistrazione],
      contributoUnificato: [this.request.contributoUnificato],
      altroImporto: [this.request.altroImporto],
      note: [this.request.note]
    });
  }

  populateSelect() {}

  save() {
    this.getRequest(this.request);
  }
}
